export default __webpack_public_path__ + "static/MyriadPro-Regular-a6158dcb922dcdf130875c8bc3170261.woff2";